import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Footer } from "../../Components/Footer/footer";
import "./style.css";

export function StatutPage() {
  const [headerImage, setHeaderImage] = useState("");
  const [description, setDescription] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "site_content", "statute_page");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setDescription(data.description || "");
        setPdfUrl(data.pdf_url || "");
      }
    };
    fetchData();
  }, []);

  return (
    <div className="page-container">
      <Navbar />

      {headerImage && (
        <div
          className="statute-banner"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
      )}

      <div className="page-content">
        <h1>Statutul Uniunii Sindicale Sanitas</h1>
        <p className="statute-description">{description}</p>

        {pdfUrl && (
          <>
            <a className="download-btn" href={pdfUrl} target="_blank" rel="noopener noreferrer">
              Descarcă PDF
            </a>
            <iframe
              src={pdfUrl}
              title="Statut PDF"
              width="100%"
              height="600px"
              style={{ border: "1px solid #ccc", marginTop: "1rem" }}
            />
          </>
        )}
      </div>

      <Footer />
    </div>
  );
}
